import React, { useState } from "react";
import { Form, Dropdown } from "semantic-ui-react";

const ColumnSetForm = ({ columnSets, handleReorder, handleReset }) => {
  const [selectedColSet, setSelectedColSet] = useState("");

  const handleDropdownChange = (event, { value }) => {
    setSelectedColSet(value);
  };

  const handleLoadClick = () => {
    if (selectedColSet) {
      handleReorder(selectedColSet);
    }
  };

  const dropdownOptions = columnSets.map((colSet) => ({
    key: colSet.columnSetName,
    text: colSet.columnSetName,
    value: colSet.columnSetName,
  }));

  return (
    <Form>
      <Form.Group>
        <div className="ui label">Select Column Set</div>
        <Form.Field>
          <Dropdown
            selection
            search
            placeholder="Select Column Set"
            value={selectedColSet}
            onChange={handleDropdownChange}
            options={dropdownOptions}
          />
        </Form.Field>
        <button
          onClick={handleLoadClick}
          className="button ui blue inverted"
          disabled={!selectedColSet}
        >
          Load
        </button>
        <button
          onClick={() => {
            handleReset();
            setSelectedColSet("");
          }}
          className="button ui blue inverted"
          disabled={!selectedColSet}
        >
          Reset
        </button>
      </Form.Group>
    </Form>
  );
};

export default ColumnSetForm;
